
import { WDFormTextselect } from './wd-form-textselect';

export class WDFormOptionselect extends WDFormTextselect
{

  #value = null;

  constructor(opts)
  {
    super(opts);

    if (opts.value) this.value = opts.value;
  };

  
  get value() { 
    return this.#value; 
  };


  set value(val)
  { 
    if (val === undefined) val = null;
    const origVal = this.#value !== null ? this.config.templates.value.interpolate(this.#value) : null;
     
    if (val === null)
    {
      this.#value = null;
      this.input.value = '';
    }
    else
    {
      const valStr = this.config.templates.value.interpolate(val);

      //passed an empty object
      if (valStr == 'null' || valStr.includes('${'))
      {
        this.#value = null;
        this.input.value = '';
      }
      else
      {
        this.#value = val;
        this.input.value = this.config.templates.label.interpolate(val);
      }
    }

    this.trigger('value:set');

    const curVal = this.#value !== null ? this.config.templates.value.interpolate(this.#value) : null;
    if (origVal != curVal) this.trigger('change');
   
  };
};

customElements.define('wd-form-optionselect', WDFormOptionselect);
